import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { T2TemplateBasicComponent } from '../../trip2-theme/components/t2-template-basic/t2-template-basic.component';
import { StandingOrderReviewedComponent } from './components/standing-order-reviewed/standing-order-reviewed.component';


const routes: Routes = [
  { path: 'pages', component: T2TemplateBasicComponent,
    children: [
      {
        path: 'standing-order',
        children: [
          {path: 'standing-order-reviewed', component: StandingOrderReviewedComponent, data: {title: 'Standing Orders'}}
        ]
      }]
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class StandingOrderRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/pages/standing-order/standing-order-routing.module.ts